module.exports = __webpack_public_path__ + "static/media/chicago-uic-small-3.22009885.jpg";